import React from 'react';
import ResourcePage from './ResourcePage';
import { getFarmerResource } from '../../data/farmerResources';

const SellerGuide = () => <ResourcePage resource={getFarmerResource('seller-guide')} />;
export default SellerGuide;
